import React from "react";
import { Squares2X2Icon, ListBulletIcon } from "@heroicons/react/20/solid";

export type ViewMode = "grid" | "list";

interface ViewToggleProps {
  view: ViewMode;
  onViewChange: (view: ViewMode) => void;
}

const ViewToggle: React.FC<ViewToggleProps> = ({ view, onViewChange }) => {
  return (
    <div className="inline-flex p-1 rounded-lg bg-zinc-100 dark:bg-zinc-800">
      <button
        type="button"
        onClick={() => onViewChange("grid")}
        className={`p-2 rounded-md transition-colors ${
          view === "grid"
            ? "bg-white dark:bg-zinc-700 text-zinc-900 dark:text-white shadow-sm"
            : "text-zinc-500 dark:text-zinc-400 hover:text-zinc-700 dark:hover:text-zinc-300"
        }`}
        aria-label="Grid view"
        title="Grid view"
      >
        <Squares2X2Icon className="w-5 h-5" />
      </button>
      <button
        type="button"
        onClick={() => onViewChange("list")}
        className={`p-2 rounded-md transition-colors ${
          view === "list"
            ? "bg-white dark:bg-zinc-700 text-zinc-900 dark:text-white shadow-sm"
            : "text-zinc-500 dark:text-zinc-400 hover:text-zinc-700 dark:hover:text-zinc-300"
        }`}
        aria-label="List view"
        title="List view"
      >
        <ListBulletIcon className="w-5 h-5" />
      </button>
    </div>
  );
};

export default ViewToggle;
